import { render } from "./Setting.vue?vue&type=template&id=311d91ea&scoped=true"
import script from "./Setting.vue?vue&type=script&lang=js"
export * from "./Setting.vue?vue&type=script&lang=js"

import "./Setting.vue?vue&type=style&index=0&id=311d91ea&lang=less&scoped=true"

import exportComponent from "D:\\xm\\zhongzai\\qianduan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-311d91ea"]])

export default __exports__